export default "<div class=\"type-element-stock\">\n  {{TypeElementStockInComponent?.Nom}}\n</div>\n";